import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, writeBatch } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyCVG-oHs3NHNC_wdnm_yBTv-bZMED-kB-4",
  authDomain: "muzilly-abf45.firebaseapp.com",
  projectId: "muzilly-abf45",
  storageBucket: "muzilly-abf45.firebasestorage.app",
  messagingSenderId: "287536166897",
  appId: "1:287536166897:web:23727bb05c60ca777ff650",
  measurementId: "G-D298QYMRD5"
};

const firebaseApp = initializeApp(firebaseConfig);
const auth = getAuth(firebaseApp);
const db = getFirestore(firebaseApp);
const storage = getStorage(firebaseApp);
const functions = getFunctions(firebaseApp);

// Web push (FCM) public key — Firebase console → Project settings → Cloud Messaging → Web Push certificates →
// "Generate key pair". Either set VUE_APP_FIREBASE_VAPID_KEY in .env, or paste the key between the quotes.
// (It's a public key, safe to ship in the client.) Push stays switched off until this is filled in.
const vapidKey = process.env.VUE_APP_FIREBASE_VAPID_KEY || "";

export { firebaseApp, auth, db, writeBatch, storage, functions, vapidKey };